import { Tag } from '@drift-labs/react';

import { UiVaultConfig } from 'src/@types/vaults';
import { twMerge } from 'tailwind-merge';
import { useMemo } from 'react';
import { HighRiskChip } from '../Chips/HighRiskChip';
import { Typo } from '../Text/Typo';
import { AlertTriangle, ShieldCheck } from '@drift-labs/icons';
import { LabelChip } from '../Chips/LabelChip';
import Tooltip from '../Tooltip/Tooltip';
import { FeeChangeMessageContent } from './FeeChanges';

export const VaultTags = (props: {
	uiVaultConfig: UiVaultConfig;
	numOfVaultSnapshots: number;
	classes?: {
		tagText?: string;
	};
}) => {
	const isNew = props.uiVaultConfig.isNew(props.numOfVaultSnapshots);
	const isHighRisk = props.uiVaultConfig.isHighRisk;
	const numberOfTags = useMemo(() => {
		let count = 0;
		if (isNew) count++;
		if (isHighRisk) count++;
		return count;
	}, [isNew, isHighRisk]);
	const isVerified = props.uiVaultConfig.vaultManager.isVerified;

	const isDeprecating = props.uiVaultConfig.isDeprecating;
	const isDeprecated = props.uiVaultConfig.isDeprecated;

	const hasFeeChangesToWarnAbout =
		props.uiVaultConfig.feeChangesToAlert?.length > 0;

	return (
		<div className="flex flex-col items-start justify-center space-y-1">
			<div className="flex items-center gap-2 flex-wrap">
				<Tag color="default" className="flex items-end gap-0.5">
					<Typo.B6 className={twMerge('px-0.5', props.classes?.tagText)}>
						{props.uiVaultConfig.vaultManager.name}
					</Typo.B6>
					{isVerified && (
						<ShieldCheck
							size={16}
							gradientColors={['#E8A2A0', '#9468F1', '#71CCE9']}
						/>
					)}
				</Tag>
				{isNew && (
					<Tag color="purple">
						<Typo.B6 className={twMerge('px-0.5', props.classes?.tagText)}>
							New
						</Typo.B6>
					</Tag>
				)}
				{isHighRisk && <HighRiskChip iconOnly={numberOfTags > 1} />}
				{isDeprecating && (
					<LabelChip
						label={`${isDeprecated ? 'Deprecated' : 'Deprecating Soon'}`}
						negative
						className="h-full"
					/>
				)}
				{hasFeeChangesToWarnAbout && (
					<Tooltip
						content={
							<>
								<FeeChangeMessageContent vaultConfig={props.uiVaultConfig} />
							</>
						}
					>
						<LabelChip
							icon={<AlertTriangle size={12} />}
							label={`Fee Update`}
							type="warning"
							className="h-full"
						/>
					</Tooltip>
				)}
			</div>
		</div>
	);
};
